// @flow
import React from 'react'

import type { SelectEnumRefIndexProps, SelectEnumRefIndexState, SelectItem } from './SelectEnumRefIndex'

import SelectEnumRefIndex, {
  hasAvailableDependeeResources,
  hasDependeeFieldChanged,
  haveValueNamesLoaded,
  hasInputValueChanged,
  getDefaultOptions,
  getDependeeValue,
  addPreferredOptions,
  applyPreferredValuesLimit,
} from './SelectEnumRefIndex'

import ReactSelect from './SelectEnumRefIndex/ReactSelect'
import ReactSelectOption from './SelectEnumRefIndex/ReactSelect/Option'

export type ModelState = SelectEnumRefIndexState & {
  oldVehicleType: string
}

const PREFERRED_OPTION_HEIGHT_IN_PIXELS: number = 43

export default class Model extends SelectEnumRefIndex<SelectEnumRefIndexProps, ModelState> {
  // noinspection JSCheckFunctionSignatures
  static getDerivedStateFromProps (nextProps: SelectEnumRefIndexProps, prevState: ModelState) {
    return getDerivedStateFromPropsLogic(nextProps, prevState, getModelSelectOptions)
  }

  renderReactSelect = (): Object => {
    return (
      <ReactSelect
        error={this.renderError()}
        name={this.props.name}
        onUpdate={this.handleOnUpdateValue}
        optionComponent={ReactSelectOption}
        options={this.state.options}
        preferredOptionHeightInPx={PREFERRED_OPTION_HEIGHT_IN_PIXELS}
        value={this.state.value}
      />
    )
  }
}

export const getDerivedStateFromPropsLogic = (
  nextProps: SelectEnumRefIndexProps,
  prevState: ModelState,
  getSelectOptions: Function): ModelState => {
  const newState = {}
  let isChanged = false

  if (hasAvailableDependeeResources(nextProps)) {
    if (hasVehicleTypeChanged(nextProps, prevState)) {
      newState.oldVehicleType = nextProps.formData.type
      isChanged = true
    }

    if (hasDependeeFieldChanged(nextProps, prevState)) {
      newState.oldDependeeValue = getDependeeValue(nextProps)
      isChanged = true
    }

    if (haveValueNamesLoaded(nextProps, prevState)) {
      newState.oldValueNames = nextProps.valueNames
      isChanged = true
    }

    if (isChanged) {
      newState.options = getSelectOptions(nextProps)
    }
  }

  if (hasInputValueChanged(nextProps, prevState)) {
    newState.value = nextProps.value
    newState.oldValue = nextProps.value

    isChanged = true
  }

  return isChanged ? newState : null
}

export const hasVehicleTypeChanged = (nextProps: SelectEnumRefIndexProps, prevState: ModelState): boolean => {
  return nextProps.formData && nextProps.formData.type && nextProps.formData.type !== prevState.oldVehicleType
}

export const getModelSelectOptions = (nextProps: SelectEnumRefIndexProps): Array<SelectItem> => {
  return addPreferredOptions(nextProps, getDefaultOptions(nextProps), getModelPreferredValues(nextProps))
}

export const getModelPreferredValues = (nextProps: SelectEnumRefIndexProps): Array<string> => {
  const dependeeType = getDependeeType(nextProps)
  const dependeeValue = getDependeeValue(nextProps)

  if (!dependeeType
    || !dependeeValue
    || !nextProps.preferredValues
    || !nextProps.preferredValues[dependeeType]
    || !nextProps.preferredValues[dependeeType][dependeeValue]) {
    return []
  }

  return applyPreferredValuesLimit(nextProps, nextProps.preferredValues[dependeeType][dependeeValue])
}

export const getDependeeType = (nextProps: SelectEnumRefIndexProps): string => {
  if (!nextProps.formData || !nextProps.formData.type) {
    return ''
  }

  return nextProps.formData.type
}
